import jQuery from "jquery";
const $ = jQuery; // ドルマークに参照を代入(慣習的な $ を使うため)

/*
 * drawer
 */
$(document).on('click','.drawer-handle', function() {
  $('body').toggleClass("--draweropen");
});
$(document).on('click','#drawer a', function() {
  $('body').toggleClass("--draweropen");
});
$(document).on('click','#footer a, #header a', function() {
  if($('body').hasClass('--draweropen')){
    $('body').toggleClass("--draweropen");
  }
});



/*
 * search
 */
$(document).on('click','.search-handle', function() {
  $('body').toggleClass("--searchopen");
  return false;
});
$(document).on('click','#search a', function() {
  $('body').toggleClass("--searchopen");
  // return false;
});
$(document).on('click','#footer a, #header a', function() {
  if($('body').hasClass('--searchopen')){
    $('body').toggleClass("--searchopen");
    // return false;
  }
});



/*
 * Facebool pageplugin responsive

var htmlStr = $('#pageplugin').html();
var timer = false;
$(window).resize(function () {
  if (timer !== false) {
    clearTimeout(timer);
  }
  timer = setTimeout(function() {
    $('#pageplugin').html(htmlStr);
    window.FB.XFBML.parse();
  }, 200);
});
*/
